import {
  parseAsString,
  parseAsArrayOf,
  parseAsBoolean,
  useQueryStates,
  parseAsActiveStatus,
} from '@vrplatform/query-params';
import { useTableStoreReset } from '../../../stores';

export const useDepositsTableFilter = () => {
  'use memo';

  const [filter, setFilter] = useQueryStates({
    search: parseAsString,
    status: parseAsActiveStatus.withDefault('active'),
    listingIds: parseAsArrayOf(parseAsString),
    connectionId: parseAsString,
    date: parseAsString,
    accountId: parseAsString,
    reconciled: parseAsBoolean,
  });

  const resetStore = useTableStoreReset();

  const setFilterWithReset = (...args: Parameters<typeof setFilter>) => {
    resetStore();
    return setFilter(...args);
  };

  return {
    filter,
    setFilter: setFilterWithReset,
    reset: () => setFilterWithReset(null),
  };
};
